import { render, staticRenderFns } from "./EditFaqCategory.vue?vue&type=template&id=f5090a80&"
import script from "./EditFaqCategory.vue?vue&type=script&lang=js&"
export * from "./EditFaqCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports